import { PARAMETER_VALUE } from '../constants/config/hash';
import { COMPARISONS, MAX_TYPE, MIN_TYPE, ERROR_CLASS, VALID_RANGE_FILTER } from '../constants/config/filters';
import { parseNumber, parseMagnitude } from './magnitudes';
import { findHashValue, hashToRange } from './hash';

/**
 * @name checkRangeError
 * @function
 * @description Determines which items of a range, if any, are invalid
 * @returns {array} list of types that have errors
 * @param {number} min minimum range value
 * @param {number} max maximum range value
 * @param {boolean} testMin Determines if the min value should be validated. If false, max is validated
 */
export const checkRangeError = ( min, max, testMin=false ) => {

    let maxCompare = parseMagnitude( max ),
    minCompare = parseMagnitude( min ),
    errors = [],
    type = testMin ? MIN_TYPE : MAX_TYPE,
    test = testMin ? min : max;

    // check for max field errors
    if( maxCompare < minCompare || !VALID_RANGE_FILTER.test( test ) ) errors.push( type );

    return errors;
}

/**
 * @name determineValue
 * @method
 * @description Determines the appropriate value to display
 * @param {string|number} value The number to be parsed
 * @param {boolean} [isMagnitude=false] Determines if the value should be treated as a magnitude
 */
export const determineValue = ( isMagnitude=false, value ) => isMagnitude ? parseNumber( value ) : parseMagnitude( value );

/**
 * @name getInitialText
 * @function
 * @description Gets the initial min/max values to display in the text inputs
 * @param {string} parameter Parameter to look for the value of
 * @param {boolean} [isMagnitude=false] Determines if the value should be treated as a magnitude
 */
export const getInitialText = ( parameter, isMagnitude=false ) => {

    const hash = findHashValue( PARAMETER_VALUE.replace( '{id}', parameter ) );

    let max, min;

    if( !hash ) return null;

    hashToRange( hash )[ parameter ].forEach( filter => {
        switch( filter.comparison ){
            case COMPARISONS.LESS_THAN:
                max = determineValue( isMagnitude, filter.value );
                break;
            case COMPARISONS.GREATER_THAN:
                min = determineValue( isMagnitude, filter.value );
                break;
            default:
                return;
        }
    });

    return { max, min };

}

/**
 * @name hasError
 * @function
 * @description Determines if the error type is included in the array
 * @param {array} errors
 * @param {string} [type=min|max] 
 * @returns {string|null}
 */
export const hasError = ( errors, type ) => errors.includes( type ) ? ERROR_CLASS : null;